<div class="position-relative">
    <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
      <div class="bg-img-hero mb-1 clearfix d-none d-xl-block" appLazyload="1920x600/kopa-porters.jpg" style="height: 300px; background-position: bottom left;"></div>
      <div class="bg-img-hero mb-1 clearfix d-none d-lg-block d-xl-none" appLazyload="1920x600/kopa-porters.jpg" style="height: 275px; background-position: bottom left;"></div>
      <div class="bg-img-hero mb-1 clearfix d-lg-none" appLazyload="1920x600/kopa-porters.jpg" style="height: 250px; background-position: 40% 0%;"></div>
      <div class="row py-5">

        <!-- Core Content -->
        <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-8 mb-7 mb-lg-0">
          <!-- Header -->
          <h1 class="text-white">
            <strong>Tipping Guide</strong>&nbsp;
            <br class="clearfix d-xl-none" />
          </h1>
          <!-- End Header -->

          <h3 id="kilimanjaro" class="mt-3">
            <strong>Kilimanjaro:</strong>&nbsp;
            <br class="clearfix d-xl-none" />
          </h3>

          <div class="mt-3 mb-5">
            <p>
              It is customary to tip your mountain crew upon completion of your trip. The decision of how much to tip your crew should be based on how well your guides, cooks, and porters cared for you while on the mountain.
            </p>
            <p>
              Tip amount(s) should not be based on your summit success.
            </p>
          </div>

          <div class="mt-3 ml-4 ml-md-5 ml-lg-8">
            <!-- Tipping -->
            <div class="row mb-4">
                <div class="d-flex">
                  <app-fa-icon iconName="user-plus" classes="u-avatar align-self-center ml-2 mr-7 text-shadow" width="3.5" height="3.5"></app-fa-icon>
                  <div>
                    <h4 class="h5 text-fg text-shadow mb-0">Head Mountain Guide</h4>
                    <span class="d-block text-fg-alt"><span class="h5">$15</span> - <span class="h5">$20</span> per day</span>
                  </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="d-flex">
                  <app-fa-icon iconName="user" classes="u-avatar align-self-center ml-2 mr-9 text-shadow" width="2.5" height="3"></app-fa-icon>
                  <div>
                    <h4 class="h5 text-fg text-shadow mb-0">Assistant Mountain Guide</h4>
                    <span class="d-block text-fg-alt"><span class="h5">$10</span> - <span class="h5">$12</span> per day</span>
                  </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="d-flex">
                  <app-fa-icon iconName="user-friends" classes="u-avatar align-self-center ml-2 mr-7 text-shadow" width="3.5" height="3.5"></app-fa-icon>
                  <div>
                    <h4 class="h5 text-fg text-shadow mb-0">Cook and Waiter</h4>
                    <span class="d-block text-fg-alt"><span class="h5">$10</span> - <span class="h5">$12</span> per day</span>
                  </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="d-flex">
                  <app-fa-icon iconName="users" classes="u-avatar align-self-center ml-2 mr-7 text-shadow" width="3.5" height="3.5"></app-fa-icon>
                  <div>
                    <h4 class="h5 text-fg text-shadow mb-0">Porters</h4>
                    <span class="d-block text-fg-alt"><span class="h5">$6</span> - <span class="h5">$7</span> each, per day</span>
                  </div>
                </div>
            </div>
            <!-- End Tipping  $370-$455-->
          </div>

          <div class="mt-3 mb-6">
              <h3>Example (7-day climb)</h3>
              <h4>On a 7-day climb for a 4 person group, your staff will comprise of:</h4>
              <ul>
                <li>1 Head Guide</li>
                <li>1 Assistant Guide</li>
                <li>1 Cook/Waiter</li>
                <li>12 Porters (3 porters per climber)</li>
              </ul>

              <p>As a group of 4, you should expect to tip between $750-$900 <b>total</b>, split between the 4 climbers. This works out to roughly
                <b>$180-$225 per climber</b> in tips. In groups larger than 4, this amount will be less per climber. In groups smaller than 4, you should expect
                  to tip more per climber.</p>
            <p>
              Tip amounts are based on recommendations made by the <a href="http://www.kilimanjaro-porters.org/" target="_blank" rel="noreferrer"><u>Mount Kilimanjaro Porters Society</u></a> (MKPS), an independent organization that advocates for the fair treatment of porters.
            </p>
            <div class="pb-3">
              <app-kopa-button text="LEARN ABOUT HOW WE SUPPORT OUR PORTERS" link="/helpful-information/porters-society" color="secondary" classes="btn-wide mb-2 mr-1"></app-kopa-button>
            </div>
            <p>
              An envelope will be provided for you at the Springlands Hotel to place your tip in.
              While you are free to tip how you please, it's best to do after you have returned to
              Springlands Hotel. The head guide can disburse fairly to the full crew, and funds
              are direct deposited into bank accounts.
            </p>

            <div class="mt-3 mb-2">
              <p>
                The above figures , dependent on the amount of days of your chosen trek.
                You may tip in any combination of US Dollars or TZ Shillings.
              </p>

              <!-- Photo Gallery -->
              <div appFancyPhotoGallery [photoGallery]="safariTruckGallery"></div>
              <!-- End Photo Gallery -->
            </div>
          </div>

          <h3>
            <strong>Safari:</strong>&nbsp;
            <br class="clearfix d-xl-none" />
          </h3>

          <div class="mt-3">
          <p>
          It is customary to tip your safari driver upon completion of your trip. The decision of how much to tip should be determined by the attentiveness of your guide, and their overall care to make your trip special and unique! It should not be based upon the amount of animals you were able to see or were hoping to see.
          </p>
          </div>

          <div class="mt-3 ml-4 ml-md-5 ml-lg-8">
            <!-- Safari Tipping -->
            <div class="row mb-4">
                <div class="d-flex">
                  <app-fa-icon classes="u-avatar align-self-center mr-6 text-shadow" iconName="shuttle-van" width="3" height="3"></app-fa-icon>
                  <div>
                    <h4 class="h5 text-fg text-shadow mb-0">Safari Guide</h4>
                    <span class="d-block text-fg-alt"><span class="h5">$50</span> - <span class="h5">$75</span> per day</span>
                  </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="d-flex">
                  <app-fa-icon classes="u-avatar align-self-center mr-6 text-shadow" iconName="concierge-bell" width="3" height="3"></app-fa-icon>
                  <div>
                    <h4 class="h5 text-fg text-shadow mb-0">Hotel Staff</h4>
                    <span class="d-block text-fg-alt"><span class="h5">$5</span> - <span class="h5">$8</span> per day</span>
                  </div>
                </div>
            </div>
            <!-- End Safari Tipping -->
          </div>


          <div class="mt-3">
          <p>
            Each safari vehicle should expect to collectively tip their driver between US $250-$350 for the entire safari expedition.
          </p>
          </div>

          <!-- Photo Gallery -->
          <div appFancyPhotoGallery [photoGallery]="porterGallery"></div>
          <!-- End Photo Gallery -->
        </div>
        <!-- End Core Content -->

        <div *ngIf="isBasePage(); else kiliTrips" class="col-12 col-sm-8 col-md-5 col-lg-5 col-xl-4 mb-7 mb-sm-0">
          <!-- Safari Sidebar -->
          <div class="position-sticky" style="top:80px; position: -webkit-sticky">
          <app-trip-list
            titleString="Book a trip today!"
            subtitleString="See available Safari adventures:"
            headerColor="secondary"
            [hasTextShadow]="false"
            [entries]=tripEntriesSafari>
          </app-trip-list>
          </div>
          <!-- End Safari Sidebar -->
        </div>
        <ng-template #kiliTrips>
          <div class="col-12 col-sm-8 col-md-5 col-lg-5 col-xl-4 mb-7 mb-sm-0">
            <!-- Safari Sidebar -->
            <div class="position-sticky" style="top:80px; position: -webkit-sticky">
              <app-trip-list
                titleString="Book a Trek today!"
                subtitleString="See available Kilimanjaro tours:"
                headerColor="secondary"
                [hasTextShadow]="false"
                [entries]=tripEntriesKilimanjaro>
              </app-trip-list>
            </div>
            <!-- End Safari Sidebar -->
          </div>
        </ng-template>
      </div>
    </div>
</div>
